import { createContext, useContext, useState, useCallback } from "react"

const DashboardFiltersContext = createContext(null)

export function DashboardFiltersProvider({ children }) {
  const [adminOnly, setAdminOnly] = useState(true)
  const [autoRefresh, setAutoRefresh] = useState(true)
  const [lastRefresh, setLastRefresh] = useState(new Date())

  const refresh = useCallback(() => {
    setLastRefresh(new Date())
  }, [])

  return (
    <DashboardFiltersContext.Provider
      value={{
        adminOnly,
        setAdminOnly,
        autoRefresh,
        setAutoRefresh,
        lastRefresh,
        refresh,
      }}
    >
      {children}
    </DashboardFiltersContext.Provider>
  )
}

export function useDashboardFilters() {
  const context = useContext(DashboardFiltersContext)
  if (!context) {
    throw new Error(
      "useDashboardFilters must be used within DashboardFiltersProvider"
    )
  }
  return context
}
